import { render, staticRenderFns } from "./commService.vue?vue&type=template&id=3d42c290&scoped=true&"
import script from "./commService.vue?vue&type=script&lang=js&"
export * from "./commService.vue?vue&type=script&lang=js&"
import style0 from "./commService.vue?vue&type=style&index=0&id=3d42c290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d42c290",
  null
  
)

export default component.exports